import { FaEnvelope, FaLock } from 'react-icons/fa';
import TextInputWithIcon from '../../components/TextInput/TextInput';
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.css';
import styles from './Login.module.css';
import {useNavigate} from 'react-router-dom';
import { useState } from 'react';


const  Login  = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://377storage.vip/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        email: formData.email,
        password: formData.password,
      }),
    });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('access_token', data.access_token);

        const userInfoResponse = await fetch('https://377storage.vip/api/me', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${data.access_token}`, // Use the token received from login
          },
        });

        const userInfo = await userInfoResponse.json();

        // Save the user's name in local storage
        localStorage.setItem('currentUser', userInfo.name);

        if(userInfo.is_admin == 1) {
          navigate('/admin-board');
        } else {
          navigate('/dashboard');
        }

      } else {
        setError(data.detail || 'Login failed');
      }
    } catch (err) {
      console.error(err);
      setError('An error occured. Please try again.')
    }
  };

return (
  <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
    {/* Blurred background image layer */}
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "url('/images/iStock-907888472.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'blur(6px)',
        zIndex: 1,
      }}
    />
    
    {/* Foreground content (signup form) */}
    <div className={styles.formContainer} style={{ position: 'relative', zIndex: 2 }}>
      <h1 className={styles.title}>Login</h1>
      <form onSubmit={handleSubmit}>
        <TextInputWithIcon
          icon={<FaEnvelope />}
          className={styles.entry}
          placeholder="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        <TextInputWithIcon
          icon={<FaLock />}
          placeholder="Password"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
        />
        {error && <div className={styles.error}>{error}</div>}
        <Button type="submit" className={buttonStyles.signup}>Login</Button>
      </form>
    </div>
  </div>
);

};

export default Login;
